import styled from 'styled-components';
import colors from '../../theme/search/colors';

const Wrapper = styled.div`
    .label--radio {
        display: flex;
        align-items: center;
        gap: 10px;
        cursor: pointer;

        > div {
            font-size: 15px;
            color: #4a4a4a;
        }

        .radio {
            -webkit-appearance: auto !important;
        }
    }
`;

const svgStyle = {
  width: 32
};

export { Wrapper, svgStyle };



// WEBPACK FOOTER //
// ./src/components/Radio/style.js